module.exports = __webpack_public_path__ + "img/icon-expand.da3a0b0f.svg";